import { useEffect, useState } from "react";
import { fetchContent, fetchGallery, fetchReviews } from "@/lib/api";

// Module-level cache so a single content fetch is shared across components
let _contentCache = null;
let _contentLoaders = [];
let _galleryCache = null;
let _reviewsCache = null;

export const useSiteContent = () => {
  const [content, setContent] = useState(_contentCache);

  useEffect(() => {
    if (_contentCache) {
      setContent(_contentCache);
      return;
    }
    _contentLoaders.push(setContent);
    if (_contentLoaders.length === 1) {
      fetchContent()
        .then((data) => {
          _contentCache = data;
          _contentLoaders.forEach((fn) => fn(data));
          _contentLoaders = [];
        })
        .catch(() => {
          _contentLoaders = [];
        });
    }
  }, []);

  return content;
};

export const invalidateContent = () => {
  _contentCache = null;
};

export const useGallery = () => {
  const [items, setItems] = useState(_galleryCache || []);
  useEffect(() => {
    fetchGallery().then((d) => {
      _galleryCache = d.items;
      setItems(d.items);
    }).catch(() => {});
  }, []);
  return items;
};

export const invalidateGallery = () => { _galleryCache = null; };

export const useReviews = () => {
  const [items, setItems] = useState(_reviewsCache || []);
  useEffect(() => {
    fetchReviews().then((d) => {
      _reviewsCache = d.items;
      setItems(d.items);
    }).catch(() => {});
  }, []);
  return items;
};

export const invalidateReviews = () => { _reviewsCache = null; };
